import React, { useState } from "react";

const FALLBACK = "/images/listings/fallback.webp";

interface ListingImageProps {
  src: string | null | undefined;
  alt: string;
  className?: string;
  /** Extra classes for the img element (overrides className on the wrapper) */
  imgClassName?: string;
  "data-testid"?: string;
}

/**
 * Drop-in replacement for <img> in listing contexts.
 * - Silently swaps to the fallback WebP when the primary src fails.
 * - Never shows a broken-image icon or browser alt-text overlay.
 * - Preserves meaningful alt text for accessibility.
 */
export function ListingImage({
  src,
  alt,
  className,
  imgClassName,
  "data-testid": testId,
}: ListingImageProps) {
  const primary = src || FALLBACK;
  const [imgSrc, setImgSrc] = useState(primary);
  const [triedFallback, setTriedFallback] = useState(false);

  const handleError = () => {
    if (!triedFallback) {
      setTriedFallback(true);
      setImgSrc(FALLBACK);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      onError={handleError}
      className={imgClassName ?? className}
      data-testid={testId}
    />
  );
}
